module.exports = "https://static.wmbcdn.com/uniweb/images/d0088d7d4eb630b80b46a281891af71f.svg";